import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex, Text } from 'Components/UI'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

export const Container = styled(Flex).attrs({
  pt: [4, 4, 0],
})`
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  position: relative;
`

export const Wrapper = styled(Flex)`
  align-items: center;
  position: relative;
`

export const Description = styled(Text).attrs({
  fontSize: [14, 14, 14, 16],
})`
  color: ${themeGet('colors.calculator.textSecondary')};
  font-weight: 400;
  line-height: 24px;
`

const Hider = styled(Flex).attrs({
  left: [0 - LANDING_INLINE_PADDINGS[0], 0],
})`
  width: 12px;
  top: 16px;
  position: absolute;
  z-index: 9;

  background-color: ${themeGet('colors.white')};
`
export const HiderTop = styled(Hider)`
  height: 200px;
  transform: translateX(-50%) translateY(-100%);
`

export const HiderBottom = styled(Hider)`
  height: 300px;
  transform: translateX(-50%);
`
